/* --------------------------------------------------------------------------------------
   settingsActionBar.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const settingsActionBarComponent = {
  template: `
  <div id="settings-action-bar" class="xrx-action-bar">
    <button xw-button class="xrx-action-bar-button-left" glyph="close" no-text ng-click="vm.cancel()"></button>
    <div class="xrx-action-bar-label"><span translate>EXPENSE_TRACKING</span></div>
    <button xw-button class="xrx-action-bar-button-right" ng-class="{ disabled: vm.disableOkStyle }" glyph="checkmark" ng-click="vm.ok()">{{ 'OK' | translate }}</button>
  </div>
  `,
  controllerAs: 'vm',
  bindings: {
    user: '<',
    ok: '&',
    cancel: '&',
    disableOkStyle: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/components/settingsActionBar.component.js